import { makeDataSample } from "./index.preview";
import { debounce } from "lodash";
import { debuglog } from "../utility/debuglog";

let isLongText = false;
let oldData = null;

export default [
  {
    name: 'Simulation',
    class: 'btn-reload-simulation',
    label: 'Simulation',
    exec: (manager) => {
      setDefaultSetting(manager)

      const times = [500, 1100, 1200, 2000, 3000, 3200, 3600, 4000, 4200, 6100, 6200, 7400, 7700, 8900];
      let simulationRIS = 0;

      // simulation running in seconds

      setInterval(() => {
        // manager.widget.simulationRIS += 100
        simulationRIS += 100
      }, 100)

      times.forEach((data) => {
        setTimeout(() => {
          reloadSimulation();
        }, data);
      });

      function reloadSimulation() {
        const amount = Math.floor(Math.random() * 100000);
        debuglog(`[${simulationRIS}ms] New tip 💰 ${h.formatPrice(amount)}`);

        reloadHandlerSimulation(simulationRIS, amount);
      }

      let reloadHandlerSimulation = debounce((ms, amount) => {
        debuglog(`[${simulationRIS}ms] Reload data from [${ms}ms]`);

        updateGoalProgressSimulation(manager, amount);
      }, 500, { 'maxWait': 1000 });
    }
  },
  {
    name: 'add-tip',
    class: 'btn-add-tip',
    label: 'Add tip',
    exec: (manager) => {
      setDefaultSetting(manager)
      const amount = Math.floor(Math.random() * 50000);
      debuglog(`New tip 💰 ${h.formatPrice(amount)}`);

      updateGoalProgressSimulation(manager, amount);
    }
  },
  {
    name: 'Randomize',
    class: 'btn-randomize',
    label: 'Randomize',
    exec: (manager) => {
      setDefaultSetting(manager)
      debuglog(`New tip randomize`);
      manager.reload(makeDataSample());
    }
  },
  {
    name: 'Reset Progress',
    class: 'btn-reset-progress',
    label: 'Reset Progress',
    exec: (manager) => {
      setDefaultSetting(manager)
      debuglog(`Reset progress`);
      manager.updateReceived(0);
    }
  },
  {
    name: 'Reload',
    class: 'btn-reload-data',
    label: 'Reload',
    exec: (manager) => {
      debuglog(`Reload data`);
      manager.loadData();
    }
  },
  {
    name: 'LongText',
    class: 'btn-debug-longtext',
    label: 'Long Text',
    exec: (manager) => {
      isLongText = true;

      debuglog(`Check long text input`);
      let text = "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
      if(h.isTrue(manager.get('use_placeholder')) && h.isTrue(manager.get('preview')) ){
        let temp = h.cloneProp(manager.widget.data);
        oldData = h.cloneProp(manager.widget.data);
        temp.targetTitle = text;
        temp.pageUrl = "trakteer.id/Loremipsumdolorsitametconsecteturadipiscingelitseddoeiusmodtemporincididuntutlaboreetdoloremagnaaliqua";
        manager.reload(temp)
      } else {
        manager.widget.setting['t_customtitle'] = text;
        manager.loadData()
      }
    }
  },
];

function updateGoalProgressSimulation(manager, amount) {
  const tempData = h.cloneProp(manager.widget.data);

  const targetReceived = parseInt(tempData.targetReceived);
  const newTargetReceived = targetReceived + amount;

  manager.updateReceived(newTargetReceived);
}
async function setDefaultSetting(manager) {
  if(isLongText) {
    isLongText = false;
    if(h.isTrue(manager.get('use_placeholder')) && h.isTrue(manager.get('preview')) ){
      let temp = oldData;
      manager.reload(temp)
    } else {
      manager.loadData()
    }
  }
}
